// extracted by mini-css-extract-plugin
export var logo = "_b7-2";
export var logoWrapper = "_b7-1";
export var strip = "_b7-0";